module.exports = __webpack_public_path__ + "img/vertical_4_5_6000.213399ac.png";